import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import 'swiper/swiper-bundle.css';
import fox1 from "../../assets/images/arts/redGold.png";

SwiperCore.use([Navigation]);

const OurTeam = () => {
    const images = [
        fox1,
        fox1,
        fox1,
        fox1,
    ]
    return (
        <div className="team-bg py-3 pb-5 text-white" id="team">
             <div className="col-12 py-4">
                    <h1 className="sec-heading text- py-md-0 pt-2 text-center">Our Team</h1>
                </div>
            <div className="slider-container pb-2 team-slider-container">
                <div className="slider-wrapp"     data-aos="fade" >
                    <Swiper
                        slidesPerView={4}
                        // navigation
                        spaceBetween={18}
                        grabCursor
                        initialSlide={0}
                        // loop
                        breakpoints={{
                           
                            190: {
                                slidesPerView: 1,
                            },
                            550: {
                                slidesPerView: 2,
                            },
                            992: {
                                slidesPerView: 4,
                            },
                        }}
                    >
                        {images.map((img, ind) => {
                            return (
                                <SwiperSlide key={ind} className='slide team-slide'>
                                   
                                    <img className="slide-img" src={img} alt="G-Fox" />
                                    <div className="slide-footer">
                                        <h2>MonoLife</h2>
                                        <p className="px-2">Lorem ipsum dolor sit amet consectetur. dolor sit amet </p>
                                    </div>
                                </SwiperSlide>
                            )
                        })
                        }
                    </Swiper>
                </div>
            </div>
        </div>
    )
}

export default OurTeam
